<div class="card-container" (mouseenter) ="mouseEnter() " data-bs-toggle="modal" attr.data-bs-target= "{{'#' + videoKey}}">
  <div class="card" style="width: 20rem ;position: relative;">
    <app-playboutton style="margin: auto;
      position: absolute;top:30%;left:40%"></app-playboutton>
    <img
      src= {{imageUrl}}
      class="card-img-top" alt="populr movie">
  </div>
  <h6 style="color:white">{{this.videoCardTitle}}</h6>
</div>

 <!-- model -->
 <div  class="modal fade bsModal" [id]="this.videoKey" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" #videoModal>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <!-- <div>{{this.videoCardTitle}}</div> -->
      <!-- <div style="width:80vw;height:80vh;padding:0px;overflow: hidden;" class="modal-body">
        <iframe id="youtubeVideo" width="100%" height="100%"  [src]="youtubeLink | safe" allowfullscreen>
        </iframe>
      </div>  -->
      <div style="width:1000px;height: 600px;">
        <embed
        [src]="youtubeLink | safe"
          wmode="transparent"
          type="video/mp4"
          width="100%" height="100%"
          allow="autoplay; encrypted-media; picture-in-picture"
          allowfullscreen
          title="Keyboard Cat"
        >
      </div>
    </div>
  </div>
</div>
